<template>
  <div>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-1'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-1'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-2'
        )
      }}</strong>
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-2-1'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-2-1'
          )
        "
      />
      <br /><br />
      <span style="padding-left: 100px" v-html="renderFormula(formula1)" />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-2-2'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-2-2'
          )
        "
      />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-2-3'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-2-3'
          )
        "
      />
      <br /><br />
      <span style="padding-left: 100px" v-html="renderFormula(formula2)" />
      <br /><br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-2-4'
          )
        "
      />
      <br /><br />
      <span style="padding-left: 100px" v-html="renderFormula(formula3)" />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-2-5'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-2-5'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-3'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-3'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.title-4'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsGencicomputingfacilitiesHelpCalculatingMethod.info-4'
          )
        "
      />
    </b-notification>
  </div>
</template>

<script>
import katex from 'katex'

export default {
  name: 'HelpCalculatingMethod',
  data () {
    return {
      formula1:
        'EC = \\sum_x \\%\\text{affectation}_x ( {GES_{\\rm fabrication_x} \\over \\text{duréedevie}_x} + FE_{\\rm élec}\\text{Consommation}_x) + GES_{\\rm gazréfrigérant} + GES_{\\rm gazoil}',
      formula2:
        'FE = {\\sum_i EC_i \\over \\sum_i \\alpha_i \\text{nbheures}_i}',
      formula3:
        'E_{\\rm calcul} = FE_{\\rm coeur} \\sum_{\\rm iscalaire} \\alpha_i \\text{nbheures}_i + FE_{GPU} \\sum_{\\rm iaccéléré} \\alpha_i \\text{nbheures}_i'
    }
  },
  methods: {
    renderFormula: function (formula) {
      return katex.renderToString(formula, {
        throwOnError: false,
        output: 'mathml'
      })
    }
  }
}
</script>
